import React, { useEffect, useState } from "react";
import { faClock, faStore } from "@fortawesome/fontawesome-free-solid";
import {
  faBiking,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import { separate } from "../../Seprate/Seprate";
import Style from "./CurrentOrderList.module.css";
import { Button } from "react-bootstrap";
import { Modal, Rate } from "antd";
import OrderPerviewList from "../OrderPerviewList/OrderPerviewList";
const CurrentOrderList = (props) => {
  // console.log(props)
  const [seconds, setSeconds] = useState();
  const [Minuts, setMinuts] = useState();
  const [hour, setHour] = useState();
  const [modalState, setModalState] = useState(false);
  const [orderDataState, setOrderDataState] = useState([]);
  useEffect(() => {
    HandleSituation(props.data.status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data.status]);

  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    } else if (seconds === 0 && Minuts > 0) {
      setTimeout(() => setMinuts(Minuts - 1), 0);
      setSeconds(59);
    } else if (seconds === 0 && Minuts === 0 && hour > 0) {
      setTimeout(() => setMinuts(Minuts - 1), 0);
      setSeconds(59);
    }
  }, [seconds, Minuts, hour]);
  const HandleSituation = (status) => {
    switch (status) {
      case "1.1":
        TimerProduct(props.data.prepare_remaining_time);
        break;
      case "1":
        TimerProduct(props.data.prepare_remaining_time);
        break;
      case "2":
        TimerProduct(props.data.delivery_remaining_time);
        break;
      default:
        // setDelivery(true);
        // setReady(true);
        break;
    }
  };
  let history = useHistory();
  const goToDeliveryLoc = () => {
    history.push("/live", props.item.id);
  };
  let supplierReady = null;
  let deliveryReady = null;
  let receive = null;
  if (props.data.status === "0") {
    supplierReady = (
      <p className={Style.waiting}>
        <FontAwesomeIcon icon={faClock} /> در انتظار تایید فروشنده{" "}
      </p>
    );
  } else if (props.data.status === "1" || props.data.status === "1.1") {
    supplierReady = (
      <>
        <li className={Style.Ready}>
          <FontAwesomeIcon icon={faStore} />
          <p>آماده سازی</p>
        </li>
        <li className={Style.ReadyTime}>
          <ul className={Style.countdown}>
            <li>
              <span id="seconds"></span>
              {seconds < 10 && seconds > 0 ? "0" + seconds : seconds}
            </li>
            <li>
              <span id="seprator"></span>:
            </li>
            <li>
              <span id="minutes"></span>
              {Minuts < 10 && Minuts > 0 ? "0" + Minuts : Minuts}
            </li>
            <li>
              <span id="seprator"></span>
              {hour > 0 ? ":" : null}
            </li>
            <li>
              <span id="hour"></span>
              {hour}
            </li>
          </ul>
        </li>
      </>
    );
  } else if (props.data.status === "2" || props.data.status === "3") {
    supplierReady = (
      <li className={Style.Ready}>
        <FontAwesomeIcon icon={faStore} />
        <p>آماده سازی</p>
      </li>
    );
  }

  if (
    props.data.status === "0" ||
    props.data.status === "1" ||
    props.data.status === "3"
  ) {
    deliveryReady = (
      <p className={Style.normalLi}>
        <FontAwesomeIcon icon={faBiking} />
      </p>
    );
  } else if (props.data.status === "1.1") {
    deliveryReady = (
      <p className={Style.coloredLi}>
        <FontAwesomeIcon icon={faBiking} />
      </p>
    );
  } else if (props.data.status === "2") {
    deliveryReady = (
      <div className={Style.status2}>
        <div className={Style.holderLi}>
          <li className={Style.Ready}>
            <p>ارسال:</p>
          </li>
          <li className={Style.DeliveryTime}>
            <ul className={Style.countdown}>
              <li>
                <span id="seconds"></span>
                {seconds < 10 && seconds > 0 ? "0" + seconds : seconds}
              </li>
              <li>
                <span id="seprator"></span>:
              </li>
              <li>
                <span id="minutes"></span>
                {Minuts < 10 && Minuts > 0 ? "0" + Minuts : Minuts}
              </li>
              <li>
                <span id="seprator"></span>
                {hour > 0 ? ":" : null}
              </li>
              <li>
                <span id="hour"></span>
                {hour}
              </li>
            </ul>
          </li>
        </div>
        {/* <li className={Style.deliverLoc} onClick={goToDeliveryLoc}>
          مکان پیک
        </li> */}
      </div>
    );
  }

  if (props.data.status === "3") {
    receive = (
      <li className={Style.coloredLi}>
        <FontAwesomeIcon icon={faMapMarkedAlt} />
        <p>تحویل</p>
      </li>
    );
  } else if (
    props.data.status === "0" ||
    props.data.status === "1" ||
    props.data.status === "1.1" ||
    props.data.status === "2"
  ) {
    receive = (
      <li className={Style.normalLi}>
        <FontAwesomeIcon icon={faMapMarkedAlt} />
        <p>تحویل</p>
      </li>
    );
  }
  function TimerProduct(time) {
    const d = Number(time);
    let h = Math.floor(d / 3600);
    let m = Math.floor((d % 3600) / 60);
    let s = Math.floor((d % 3600) % 60);

    let hDisplay = h > 0 ? h : "";
    let mDisplay = m < 10 ? "0" + m : m;
    let sDisplay = s < 10 ? "0" + s : s;
    setSeconds(sDisplay);
    setMinuts(mDisplay);
    setHour(hDisplay);
  }

  return (
    // <section className={Style.RestaurantInfoHolder}>
    <div className={Style.RestaurantInfoHolder__TopPart}>
      <Modal
        title="لیست محصولات"
        open={modalState}
        onCancel={() => setModalState(false)}
        destroyOnClose
        width="92%"
        style={{ direction: "rtl", maxWidth: "500px", margin: "20px auto" }}
        closeIcon={<></>}
        footer={
          <Button
            className={Style.closeModalButton}
            onClick={() => setModalState(false)}
          >
            بستن
          </Button>
        }
      >
        <OrderPerviewList data={orderDataState} />
      </Modal>
      <div className={Style.picAndText}>
        <div className={Style.ImageHolder}>
          <img
            src={`https://cdn.barest.ir/supplier/logo/${props.data.logo}.jpg`}
            alt="restaurant"
          />
        </div>
        <div className={Style.TextHolder}>
          <h3>
            <FontAwesomeIcon icon={faStore} className={"storeIcon"} />
            {props.data.name}
          </h3>
          <div className={Style.StoreRate}>
          <Rate allowHalf defaultValue={props.data.supplier_rate} disabled/>
          </div>
          <p className={Style.address}>
            <FontAwesomeIcon
              className={Style.markerIcon}
              icon={faMapMarkerAlt}
            />
            {props.data.address}
          </p>
        </div>
      </div>
      <div className={Style.supplierPrice}>
        <span className={Style.totalPrice}>
          {separate(props.data.total)}تومان
        </span>
      </div>
      <div className={Style.RestaurantInfoHolder__BottomPart}>
        <ul className={Style.Situation}>
          {supplierReady}

          {deliveryReady}

          {receive}
        </ul>
      </div>
      <Button
        className={Style.ProductListButton}
        onClick={() => {
          setModalState(true);
          setOrderDataState(props.data.products);
        }}
      >
        لیست اقلام سفارش داده شده
      </Button>
    </div>
  );
};

export default CurrentOrderList;
